import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { StyledClientFilterItem } from "views/Tasks/styles";
import ClientIncomeTaxActivityTracesLog from "./clientTracesActivity";
import { useSearchParams } from "react-router-dom";
import ClientIncomeTaxTanActivityLog from "./clientTanActivity";

const TanClientIncomeTaxActivityLog = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "tanActivity";
  const [active, setActive] = useState(defaultTab);

  useEffect(() => {
    setActive(defaultTab);
  }, [defaultTab]);

  const handleTabChange = (tab: string) => {
    setActive(tab);
    setSearchParams({ tab });
  };

  return (
    <Box pl={1} pr={1} mt={0} pt={0}>
      <Box
        pl={2}
        pr={2}
        mb={0}
        mt={0}
        pt={0}
        pb={0}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box display="flex" gap="15px" flexWrap="wrap" alignItems="center">
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "tanActivity" ? 1 : 0}
            onClick={() => handleTabChange("tanActivity")}
          >
            TAN
          </StyledClientFilterItem>
          <StyledClientFilterItem
            variant="body1"
            color="rgba(0,0,0,0.7)"
            active={active === "tracesActivity" ? 1 : 0}
            onClick={() => handleTabChange("tracesActivity")}
          >
            Traces
          </StyledClientFilterItem>
        </Box>
      </Box>
      {active === "tanActivity" && <ClientIncomeTaxTanActivityLog tab="tanActivity" />}
      {active === "tracesActivity" && <ClientIncomeTaxActivityTracesLog tab="tracesActivity" />}
    </Box>
  );
};
export default TanClientIncomeTaxActivityLog;
